import React from 'react';
import Header from '../../../../Header/Header';
import Navigationbar from '../../../../Navigationbar/Navigationbar';
import SPRODockMapping from './SPRODockMapping';


const SPRODockMappingNav = (props) => {

    const { themeSelected } = props;

    return (
        <div className='container-fluid m-1'>
            <Header {...props} />
            <Navigationbar {...props} />
            <SPRODockMapping className='mt-3' themeSelected={themeSelected} />
        </div>
    )
}

export default SPRODockMappingNav;